/* eslint-disable camelcase */
import apis from "../../core/apis.js";
import isNil from "lodash/fp/isNil";
class ContractsResource {
  constructor($resource, Upload) {
    "ngInject";
    this.Upload = Upload;
    this.$resource = $resource;
  }

  getAll(options) {
    return this.$resource(apis.contracts).get(options);
  }

  get(id) {
    return this.$resource(apis.contracts + id).get();
  }

  getActive(options) {
    return this.$resource(
      apis.contracts + "corporate/" + options.corporateId + "/active"
    ).get();
  }

  search(search = "") {
    return this.$resource(apis.contracts).get({ search });
  }

  post(data) {
    const {
      file,
      contract_type,
      corporate,
      subscriptions,
      deduction_plan,
      penalty_plan,
      start_date,
      expiry_date,
      account_managers,
    } = data;

    const formattedData = {
      document: isNil(file) ? file : file.source,
      contract_type,
      corporate,
      subscriptions,
      deduction_plan,
      penalty_plan,
      start_date,
      expiry_date,
      account_managers,
    };

    return this.Upload.upload({
      url: apis.contracts,
      data: formattedData,
    });
  }

  documentUpload(data) {
    const url = `${apis.contracts}/attach`;
    const request = this.Upload.upload({ url, data });
    return { $promise: request };
  }

  update(id, item) {
    return this.$resource(apis.contracts + id, null, {
      update: { method: "PATCH" },
    }).update(item);
  }

  changeStatus(id, item) {
    return this.$resource(apis.contracts + id + "/change_status", null, {
      update: { method: "PUT" },
    }).update(item);
  }
}

export default ContractsResource;



// WEBPACK FOOTER //
// ./src/resources/contracts/contracts.resource.js